import React, { useCallback, useState } from 'react';
import FeedbackCommentRowRender from '../FeedbackCommentRowRender';
import { SectionCommentRowExtendedProps } from '../SectionCommentRow';
import { getSurveyAnswer } from '../FeedbackImpactReceipt/ReportCustomQuestions';
import {
  CustomQuestion,
  isInitialCustomQuestion,
} from 'admin/pages/ManageAccounts/CustomQuestions/utilts';
import { FeedbackComments } from '../utils';
import { getCustomQuestionId } from '../api';

const combineArrays = <T,>(arr1: T[] = [], arr2: T[] = []) => {
  return [...arr1, ...arr2];
};

interface FeedbackCustomQuestionsProps
  extends Omit<
    SectionCommentRowExtendedProps,
    'answer' | 'questionId' | 'title' | 'comments'
  > {
  comments: FeedbackComments;
  customQuestions: CustomQuestion[];
}

const FeedbackCustomQuestions: React.FC<FeedbackCustomQuestionsProps> = ({
  comments,
  reportId,
  userName,
  userType,
  report,
  className,
  currentUserId,
  customQuestions,
  currentUserEmail,
  feedbackSectionId,
  selectedCommentSection,
  deleteComment,
  addOrUpdateComment,
}) => {
  const [open, setOpen] = useState<{ [questionId: number]: boolean }>({});

  const handleOpen = useCallback(
    (questionId: number) => {
      setOpen(s => ({ ...s, [questionId]: !s[questionId] }));
    },
    [open, setOpen],
  );

  return (
    <>
      {customQuestions.map(c => {
        if (
          report.stage === 'INITIAL' &&
          !isInitialCustomQuestion(c.reportStage)
        ) {
          return;
        }
        return c.questions.map(q => {
          const qId = typeof q.dbId === 'number' ? q.dbId : Number(q.dbId);
          const questionId = Number(getCustomQuestionId(qId));
          const questionComments = combineArrays(
            comments[qId],
            comments[questionId],
          );

          if (
            selectedCommentSection === 'commented' &&
            questionComments.length === 0
          ) {
            return null;
          }

          return (
            <FeedbackCommentRowRender
              key={q.dbId}
              open={open[questionId]}
              questionId={questionId}
              reportId={reportId}
              report={report}
              title={q.questionText}
              userName={userName}
              userType={userType}
              allAnswers={[]}
              feedbackSectionId={feedbackSectionId}
              currentUserId={currentUserId}
              currentUserEmail={currentUserEmail}
              className={className}
              answer={{
                date1: null,
                date2: null,
                questionId,
                questionText: q.questionText,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                questionType: q.questionType as any,
                text: getSurveyAnswer(q.questionType, q.answer),
                dbId: questionId,
                question: {
                  dbId: questionId,
                  section: feedbackSectionId,
                  text: q.questionText,
                  // eslint-disable-next-line @typescript-eslint/no-explicit-any
                  questionType: q.questionType as any,
                },
              }}
              comments={questionComments}
              handleOpen={() => handleOpen(questionId)}
              deleteComment={deleteComment}
              addOrUpdateComment={addOrUpdateComment}
            />
          );
        });
      })}
    </>
  );
};

export default FeedbackCustomQuestions;
